import CustomButton from 'components/Buttons/CustomButton'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, CardBody, Container } from 'reactstrap'
import successTrx from '../../assets/images/success-trx.png'

const SuccesTransaction = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dataState = location.state

  const handleClick = () => {
    navigate('/')
  }

  return (
    <Container fluid className="custom-container mt-5">
      <Card className="border-0 shadow-sm">
        <CardBody>
          <div className="d-flex justify-content-center">
            <img
              style={{ width: '280px', height: '182px' }}
              alt="success transaction"
              src={successTrx}
            />
          </div>
          <h6 style={{ fontWeight: 'bold' }} className="text-center mt-3" data-testid="transaction-success-title">
            {dataState?.title
              ? dataState?.title
              : dataState?.isManual
                ? 'Transaksi berhasil!'
                : 'Pembayaran Anda sudah diterima!'}
          </h6>
          <p className="text-center" data-testid="transaction-success-description">
            {dataState?.desc
              ? dataState?.desc
              : dataState?.isManual
                ? 'Transaksi sudah berhasil diproses. Silahkan melihat detail transaksi pada daftar transaksi.'
                : 'Silakan tunggu penjual memproses pesanan Anda.'}
          </p>
          <div className="d-flex justify-content-center">
            <CustomButton onClick={handleClick} color="primary" testId="transaction-success-home-button">
              Kembali ke Beranda
            </CustomButton>
          </div>
        </CardBody>
      </Card>
    </Container>
  )
}

export default SuccesTransaction
